import React from 'react'
import { ReactComponent as IconSource } from '../../../images/icons/icon_source.svg'
import dayjs from 'dayjs'

type InventoryFeedStepProps = {
  date: Date
  inventory_data_provider_name?: string
}

export default function InventoryFeedStep({
  path,
}: {
  path: InventoryFeedStepProps
}): JSX.Element {
  return (
    <div
      className={'bg-primary-xiketic p-4 rounded-2xl min-w-60 h-fit flex flex-col gap-3'}>
      <div className={'flex flex-1 flex-col gap-1 items-center'}>
        <span className="text-md font-bold text-white">Inventory Feed</span>
        <span className="text-xs font-bold text-gainsboro-gray/70">
          {dayjs(path?.date).format('MMM D, YYYY')}
        </span>
      </div>
      {path?.inventory_data_provider_name && (
        <div
          className={
            'bg-blue-aero/30 text-white font-bold text-xs rounded-sm p-2 flex flex-row gap-2 items-center'
          }>
          <IconSource className={'stroke-blue-aero'} />
          {path?.inventory_data_provider_name}
        </div>
      )}
      <span className="text-white font-bold text-xs">
        Vehicle first seen on {dayjs(path?.date).format('M/D/YY')}
      </span>
    </div>
  )
}
